import React, { useState } from 'react';
import { EnvelopeIcon, ChatBubbleLeftRightIcon, QuestionMarkCircleIcon } from '@heroicons/react/24/outline';

export default function ContactUs() {
  const [copied, setCopied] = useState(false);
  const contactEmail = 'sumantbhandari@gmail.com';

  const handleCopyEmail = () => {
    navigator.clipboard.writeText(contactEmail);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const handleEmailClick = () => {
    window.location.href = `mailto:${contactEmail}`;
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-purple-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">
            Get in Touch
          </h1>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Have questions, feedback, or need assistance? We'd love to hear from you.
          </p>
        </div>

        {/* Main Contact Card */}
        <div className="bg-white rounded-2xl shadow-xl overflow-hidden mb-8">
          <div className="bg-gradient-to-r from-blue-600 to-purple-600 px-8 py-6">
            <div className="flex items-center justify-center">
              <EnvelopeIcon className="h-12 w-12 text-white mr-4" />
              <h2 className="text-2xl font-bold text-white">Contact Us</h2>
            </div>
          </div>

          <div className="px-8 py-10">
            <div className="text-center mb-8">
              <p className="text-gray-700 text-lg mb-6">
                For any inquiries, please reach out to us at:
              </p>
              
              <div className="bg-gray-50 rounded-lg p-6 mb-6 border-2 border-gray-200">
                <a 
                  href={`mailto:${contactEmail}`}
                  className="text-2xl font-semibold text-blue-600 hover:text-blue-700 transition-colors"
                >
                  {contactEmail}
                </a>
              </div>

              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <button
                  onClick={handleEmailClick}
                  className="inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-lg text-white bg-blue-600 hover:bg-blue-700 transition-colors shadow-md hover:shadow-lg"
                >
                  <EnvelopeIcon className="h-5 w-5 mr-2" />
                  Send Email
                </button>
                
                <button
                  onClick={handleCopyEmail}
                  className="inline-flex items-center justify-center px-6 py-3 border-2 border-blue-600 text-base font-medium rounded-lg text-blue-600 bg-white hover:bg-blue-50 transition-colors"
                >
                  {copied ? (
                    <>
                      <svg className="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                      </svg>
                      Copied!
                    </>
                  ) : (
                    <>
                      <svg className="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" />
                      </svg>
                      Copy Email
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Info Cards */}
        <div className="grid md:grid-cols-3 gap-6">
          <div className="bg-white rounded-xl shadow-md p-6 text-center hover:shadow-lg transition-shadow">
            <div className="flex justify-center mb-4">
              <QuestionMarkCircleIcon className="h-12 w-12 text-blue-600" />
            </div>
            <h3 className="text-lg font-semibold text-gray-900 mb-2">
              General Inquiries
            </h3>
            <p className="text-gray-600 text-sm">
              Questions about our services, features, or how to get started
            </p>
          </div>

          <div className="bg-white rounded-xl shadow-md p-6 text-center hover:shadow-lg transition-shadow">
            <div className="flex justify-center mb-4">
              <ChatBubbleLeftRightIcon className="h-12 w-12 text-purple-600" />
            </div>
            <h3 className="text-lg font-semibold text-gray-900 mb-2">
              Support
            </h3>
            <p className="text-gray-600 text-sm">
              Technical issues, account help, or troubleshooting assistance
            </p>
          </div>

          <div className="bg-white rounded-xl shadow-md p-6 text-center hover:shadow-lg transition-shadow">
            <div className="flex justify-center mb-4">
              <svg className="h-12 w-12 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
            <h3 className="text-lg font-semibold text-gray-900 mb-2">
              Feedback
            </h3>
            <p className="text-gray-600 text-sm">
              Share your ideas, suggestions, or experiences with us
            </p>
          </div>
        </div>

        {/* Response Time Notice */}
        <div className="mt-8 bg-blue-50 border border-blue-200 rounded-lg p-6 text-center">
          <p className="text-blue-800">
            <span className="font-semibold">We typically respond within 24-48 hours.</span>
            <br />
            Thank you for your patience!
          </p>
        </div>
      </div>
    </div>
  );
}
